import React, { useEffect, useState } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const DGSP = () => {

  const [expandida, setExpandida] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleImagen = (id) => {
    setExpandida(expandida === id ? null : id);
  };

  return (
    <div
      className='container-full-width'
      style={{
        backgroundImage: `url('https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/DGSP2026.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}
    >
      <div className='row'>
        <div className='col-12'>

          <h3
            className='title'
            style={{
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Dirección General <br />de Servidores del Pueblo
          </h3>

          <div className="hero">

            <h4>POLÍGONOS</h4>
            <p></p>
            <div className="contenedor">
              <img
                src="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/POL-01.jpg"
                alt="POL-01"
                className={expandida === 1 ? "img expandida" : "img"}
                onClick={() => toggleImagen(1)}
              />
            </div>

            <br />  <p></p>

            <div className="contenedor">
              <img
                src="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/POL-02.jpg"
                alt="POL-02"
                className={expandida === 2 ? "img expandida" : "img"}
                onClick={() => toggleImagen(2)}
              />
            </div>
              

          </div>

          <hr className='hr-gob' />

        </div>
      </div>
    </div>
  );
};

export default DGSP;